module.exports = __webpack_public_path__ + "static/img/ES.88b472c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/ES.svg
// module id = YV+1
// module chunks = 66